export default {
    // 根据环境变量自动选择API地址
    api: process.env.API_BASE_URL,
    // api: "http://192.168.1.235:8700",
}



// WEBPACK FOOTER //
// ./src/serve.js